<mat-card appearance="raised" class="padding-left-rt-0 review-tabs-card reviewAllCard">
    <mat-card-content>
        <app-review-all-sol-tabs></app-review-all-sol-tabs>
    </mat-card-content>
</mat-card>